import { Component, AfterViewInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  AbstractControl,
  Validators,
  ValidatorFn,
} from '@angular/forms';
import { MaincontainerComponent } from '../maincontainer/maincontainer.component';
import { Base } from '../common/base';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { MatTableDataSource } from '@angular/material/table';
import { ConsultaMisAfiliacionesModel } from '../../models/afiliaciones/afiliaciones';
import { AfiliacionService } from '../../services/mis-afiliaciones/mis-afiliaciones.service';
import { UserLoggedResponse } from '../../models/user';
import { StorageService } from '../../utils/util.storage.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { MY_DATE_FORMATS } from '../../utils/date-format';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from '@angular/material/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { CodigoAsesorService } from '../../services/codigo-asesor/codigo-asesor.service';
import { of, forkJoin } from 'rxjs';
import { switchMap, catchError, map } from 'rxjs/operators';
import moment, { Moment } from 'moment';
import { TrackData } from '../../models/app-track/track-data.model';
import { TrackingService } from '../../services/app-track/tracking.service';
import { AuthService } from '../../services/security/auth.service';


@Component({
  selector: 'app-afiliaciones',
  templateUrl: './afiliaciones.component.html',
  styleUrls: ['./afiliaciones.component.css'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE],
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
  ],
})
export class AfiliacionesComponent extends Base implements AfterViewInit {
  // Variables
  frmAfiliaciones: FormGroup;
  afiliaciones: ConsultaMisAfiliacionesModel[] = [];
  afiliacionesAFE: ConsultaMisAfiliacionesModel[] = [];
  afiliacionesShare: ConsultaMisAfiliacionesModel[] = [];

  lineas = ['CEM', 'Medicina Integral', 'Salud Oral'];
  planes = ['Asociado', 'Familiar', 'Colectivo', 'Asesor', 'Empleado'];
  tiposSolicitud = ['Inclusión', 'Venta Nueva', 'Reactivación', 'Traslado'];
  canales = ['AFE', 'SHAREPOINT'];

  today: Date = new Date();
  minFechaRadicacion: Date = new Date();
  maxFechaRadicacion: Date = new Date();
  haveResponde: boolean = false;
  haveDataToShow: boolean = false;
  dsAfiliaciones = new MatTableDataSource<any>();
  attrData: string[] = [
    'Contratante',
    'identificacion',
    'Linea',
    'Plan',
    'Programa',
    'TipoSolicitud',
    'Estado',
    'Canal',
    'FechaRadicacion',
  ];
  namesColumns: string[] = [
    'Contratante',
    'No. De Identificación',
    'Línea',
    'Plan',
    'Programa',
    'Tipo de Solicitud',
    'Estado',
    'Canal',
    'Fecha de Radicación',
  ];
  generalMessage: string = '';
  logInfo: any;
  cedula_Asesor: any;
  nombre_Asesor: any;
  trackDataCarnet!: TrackData;

  constructor(
    private servicioAfiliaciones: AfiliacionService,
    private spinner: NgxSpinnerService,
    private fb: FormBuilder,
    private mainCmp: MaincontainerComponent,
    private storageService: StorageService,
    private codigoAsesorService: CodigoAsesorService,
    private trackingService: TrackingService,
    private authService: AuthService
  ) {
    super();
    this.frmAfiliaciones = this.fb.group({
      identificacion: [
        '',
        [Validators.maxLength(20), this.noSpacesValidator()],
      ],
      linea: [''],
      plan: [''],
      programa: [''],
      tipoSolicitud: [''],
      canal: [''],
      fechaRadicacion: [null],
    });
    this.minFechaRadicacion.setMonth(this.today.getMonth() - 6); // 6 meses atrás
    this.maxFechaRadicacion = new Date(); // Fecha actual
  }

  get getControl(): { [key: string]: AbstractControl } {
    return this.frmAfiliaciones.controls;
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.mainCmp.setTitle('CONSULTA MIS AFILIACIONES');
    });
  }

  async ngOnInit(): Promise<void> {
    this.logInfo = await this.authService.getAuthInfo();
    console.log('servicio auth documento', this.logInfo);
    const userCC = this.logInfo?.document;
    this.cedula_Asesor = userCC.split('.')[1].trim();
    console.log('PortafolioComponent: cedulaAsesor ->', this.cedula_Asesor);
    this.nombre_Asesor = this.logInfo
          ? `${this.logInfo.nombre ?? ''} ${this.logInfo.primerApellido ?? ''} ${
              this.logInfo.segundoApellido ?? ''
            }`.trim()
          : 'N/A';
    console.log('PortafolioComponent: nombreAsesor ->', this.nombre_Asesor);
  
    this.trackDataCarnet = {
      module: 'Mis afiliaciones',
      category: 'N/A',
      submodule: 'Consulta mis afiliaciones',
      functionality: 'Consultar',
      cedulaAsesor: this.cedula_Asesor,
      fechaInteraccion: this.getCurrentTimestamp(),
      nombreAsesor: this.nombre_Asesor,
      identificadorInteraccion: 'AFL_CONSULTA_AFL_CONSULTAR'
    };
  }; 

  consultar(): void {
    this.spinner.show();
    this.generalMessage = '';

    const userCC: UserLoggedResponse = this.storageService.getItem('user');
    if (!userCC?.document) {
      this.spinner.hide();
      this.generalMessage = 'No se encontró el documento del asesor.';
      return;
    }

    const cedulaAsesor = userCC.document.split('. ')[1] || userCC.document;
    const canalSeleccionado = this.frmAfiliaciones.get('canal')?.value || '';

    this.codigoAsesorService
      .getCodigoAsesor(cedulaAsesor)
      .pipe(
        switchMap((codigoAsesor) => {
          const filtros = this.frmAfiliaciones.value;

          const fechaRadicacion = filtros.fechaRadicacion
            ? new Date(filtros.fechaRadicacion).toISOString().split('T')[0]
            : '';

          // 🔹 Detectar líneas adicionales
          let lineasBusqueda = [filtros.linea || ''];
          if (filtros.linea === 'Medicina Integral') {
            lineasBusqueda.push('SMP');
          } else if (filtros.linea === 'Salud Oral') {
            lineasBusqueda.push('SAO');
          }

          // Crear requests para cada línea
          const requests = lineasBusqueda.map((linea) => {
            const bodyAfiliacion = {
              nombreClave: 'getAfeAfilia',
              jsonParametros: JSON.stringify({
                prm_docuase: String(cedulaAsesor),
                prm_identificacion: filtros.identificacion || '',
                prm_linea: linea,
                prm_plan: filtros.plan || '',
                prm_tiposoli: filtros.tipoSolicitud || '',
                prm_estado: filtros.estado || '',
                prm_fecharadi: '',
              }),
            };

            const bodyShare = {
              nombreClave: 'getlistaVentasNacionalCMP',
              jsonParametros: JSON.stringify({
                codAsesorAfilmed: String(codigoAsesor),
                numIdentificacion: filtros.identificacion || '',
                lineaDeNegocio: linea,
                Plan_: filtros.plan || '',
                Programa: filtros.programa || '',
                tipoNovedad: filtros.tipoSolicitud || '',
                fecRadicacion: '',
              }),
            };

            return forkJoin({
              afiliacion: this.servicioAfiliaciones
                .consultarSolicitudesDeAfiliacion(bodyAfiliacion)
                .pipe(catchError(() => of({ data: [] }))),
              share: this.servicioAfiliaciones
                .consultarSolicitudesDeAfiliacionSharePoint(bodyShare)
                .pipe(catchError(() => of({ data: [] }))),
            }).pipe(
              map(({ afiliacion, share }) => {
                const afiliacionesAFE = (afiliacion?.data ?? []).map(
                  (item: any) => ({
                    Contratante: item.CONTRATANTE?.trim() || '',
                    identificacion: item.IDENTIFICACION?.trim() || '',
                    Linea: item.LINEA?.trim() || '',
                    Plan: item.PLAN?.trim() || '',
                    Programa: item.PROGRAMA?.trim() || '',
                    TipoSolicitud: item.TIPOSOLI?.trim() || '',
                    Estado: item.ESTADO?.trim() || '',
                    Canal: 'AFE',
                    FechaRadicacion: item.FECHARADI?.trim() || '',
                  })
                );

                const afiliacionesShare = (share?.data ?? []).map(
                  (item: any) => ({
                    Contratante: item.NCONTRATANTE?.trim() || '',
                    identificacion: item.DOCUMENTO?.trim() || '',
                    Linea: item.LINEA_SERVICIO?.trim() || '',
                    Plan: item.PLAN_AFILIACION?.trim() || '',
                    Programa: item.PROGRAMA_AFILIACION?.trim() || '',
                    TipoSolicitud: item.TIPO_SOLICITUD?.trim() || '',
                    Estado: item.ESTADO_AFILIACION?.trim() || '',
                    Canal: 'SHAREPOINT',
                    FechaRadicacion: item.FECHA_RADICACION?.trim() || '',
                  })
                );

                return [...afiliacionesAFE, ...afiliacionesShare];
              })
            );
          });

          // Combinar resultados de todas las líneas
          return forkJoin(requests).pipe(
            map((resultadosPorLinea) => {
              let datosTotales = resultadosPorLinea.flat();

              // Filtrar por canal si aplica
              if (canalSeleccionado) {
                datosTotales = datosTotales.filter(
                  (item) => item.Canal === canalSeleccionado
                );
              }

              // Filtrar por fecha desde el FRONT
              if (fechaRadicacion) {
                datosTotales = datosTotales.filter((item) => {
                  const fechaItem = item.FechaRadicacion?.substring(0, 10);
                  return fechaItem === fechaRadicacion;
                });
              }

              return datosTotales;
            })
          );
        })
      )
      .subscribe({
        next: (datosTotales) => {
          this.spinner.hide();
          this.afiliaciones = datosTotales;
          this.dsAfiliaciones.data = datosTotales;

          this.haveDataToShow = datosTotales.length > 0;
          this.haveResponde = true;
          this.generalMessage = this.haveDataToShow
            ? ''
            : 'No se encontraron resultados.';
        },
        error: (error) => {
          this.spinner.hide();
          console.error('Error al consultar datos:', error);
          this.generalMessage =
            'Error al consultar los datos. Inténtalo de nuevo más tarde.';
          this.haveResponde = true;
          this.haveDataToShow = false;
          this.dsAfiliaciones.data = [];
        },
      });
  }

  clear() {
    this.frmAfiliaciones.reset();
    this.haveDataToShow = false;
    this.generalMessage = '';
    this.dsAfiliaciones.data = [];
    this.haveResponde = false;
  }

  onChangeFechaRadicacion(event: MatDatepickerInputEvent<Date>) {
    const selectedDate = event.value ? moment(event.value) : null;
    this.frmAfiliaciones.get('fechaRadicacion')?.setValue(selectedDate);
  }

  override hasError(control: AbstractControl | null): boolean {
    return !!(control && control.invalid && (control.dirty || control.touched));
  }

  override printError(
    control: AbstractControl | null,
    customMessages?: { [key: string]: string }
  ): string {
    if (!control || !control.errors) return '';

    const errors = control.errors;
    const messages: { [key: string]: string } = {
      required: 'Este campo es obligatorio.',
      maxlength: `Longitud máxima excedida.`,
      noSpaces: 'No se permite espacios.',
      matDatepickerParse: 'Fecha inválida. Usa el formato YYYY/MM/DD.',
      ...customMessages,
    };

    const firstErrorKey = Object.keys(errors)[0];
    return messages[firstErrorKey] || 'Error desconocido.';
  }

  noSpacesValidator(): ValidatorFn {
    return (control: AbstractControl) => {
      const hasSpaces = /\s/.test(control.value);
      return hasSpaces ? { noSpaces: true } : null;
    };
  }

  private getCurrentTimestamp(): string {
  const fecha = new Date();
  const yyyy = fecha.getFullYear();
  const MM = (fecha.getMonth() + 1).toString().padStart(2, '0');
  const dd = fecha.getDate().toString().padStart(2, '0');
  const HH = fecha.getHours().toString().padStart(2, '0');
  const mm = fecha.getMinutes().toString().padStart(2, '0');
  const ss = fecha.getSeconds().toString().padStart(2, '0');
  return `${yyyy}-${MM}-${dd} ${HH}:${mm}:${ss}`;
  }
}
